export default __webpack_public_path__ + "5f1a0b6fd0d00e676a7e2e39e79e4e6e.jpg";